import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { MarkerWithLabel } from "./MarkerWithLabel";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface StartingPointMarkerProps {
  position: { lat: number; lng: number };
  onPress?: () => void;
  zIndex?: number;
}

const START_POINT_MARKER_SIZE = 40;

const StartingPointMarker: FunctionComponent<StartingPointMarkerProps> = ({
  position,
  onPress,
  zIndex,
}) => {
  const { t } = useTranslation();

  return (
    <MarkerWithLabel
      position={position}
      name={t("screens.plan.startPoint")}
      icon={icon}
      size={START_POINT_MARKER_SIZE}
      onClick={onPress}
      zIndex={zIndex}
    />
  );
};

const svgPath = `<svg width="40" height="40" viewBox="26 11 40 40" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter id="shadow" x="0" y="0" width="1.5" height="1.5">
      <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#000" flood-opacity="0.4"/>
    </filter>
  </defs>
  <g filter="url(#shadow)">
    <path d="M30 21C30 17.6863 32.6863 15 36 15H56C59.3137 15 62 17.6863 62 21V41C62 44.3137 59.3137 47 56 47H36C32.6863 47 30 44.3137 30 41V21Z" fill="white" shape-rendering="crispEdges"/>
    <path d="M46.0003 22.6667C42.7787 22.6667 40.167 25.2784 40.167 28.5001C40.167 32.6667 46.0003 39.3334 46.0003 39.3334C46.0003 39.3334 51.8337 32.6667 51.8337 28.5001C51.8337 25.2784 49.222 22.6667 46.0003 22.6667ZM46.0003 30.5834C44.8495 30.5834 43.917 29.6509 43.917 28.5001C43.917 27.3492 44.8495 26.4167 46.0003 26.4167C47.1512 26.4167 48.0837 27.3492 48.0837 28.5001C48.0837 29.6509 47.1512 30.5834 46.0003 30.5834Z" fill="${colors.primary60}"/>
  </g>
</svg>`;
const icon = `data:image/svg+xml,${encodeURIComponent(svgPath)}`;

export { StartingPointMarker };
